import BaseObject from './BaseObject'

class Config extends BaseObject {
  static _primaryKey = 'config_id'
  static _apiBaseRoute = 'config'
  static _objectType = 'config'
  static _isMapable = true
  static _isExportable = true
  static _propConfigs = [
    {
      property_name: 'config_id'
    },
    {
      property_name: 'name',
      validate: 'required'
    },
    {
      property_name: 'section',
      validate: 'required'
    },
    {
      property_name: 'value',
      validate: 'required'
    },
    {
      property_name: 'app',
      validate: 'required',
      allowEmptyString: true
    }
  ]
  constructor(row = {}, prefix = '', hasManyPostfix = null) {
    super(row)
    this.prefix = prefix
    this.hasManyPostfix = hasManyPostfix
    if (Object.keys(row).length > 0) {
      this._propConfigs.forEach(propName =>
        this._addPropIfExists(propName, row)
      )
    }
  }
  isEquivalent = item => {
    return (
      this.name &&
      item.name &&
      this.name.toLowerCase() === item.name.toLowerCase() &&
      this.section &&
      item.section &&
      this.section.toLowerCase() === item.section.toLowerCase()
    )
  }
  get optionName() {
    return `${this[this._primaryKey]}: ${this.name}-${this.section}`
  }
}

export default Config
